import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {getUniqueName} from '../question-helper';

@Component({
    selector: 'app-question-slider',
    templateUrl: './question-slider.component.html',
    styleUrls: ['./question-slider.component.scss'],
    standalone: false
})
export class QuestionSliderComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() useQuestionPromptLabel = false;
  @Input() labelText = '';
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = getUniqueName('question-slider');

  constructor() { }

  ngOnInit(): void {
    
    if (!this.question.excess_min && this.question?.excess === 1){
        this.question.excess_min = this.question.excess_mod_min;
        this.question.excess_max = this.question.excess_mod_max;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.answer) {
        this.question.answer = this.question?.answer?.replace('R', '')?.replace(/ /g, '');
      }
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.useQuestionPromptLabel?.currentValue !== changes?.useQuestionPromptLabel?.previousValue) {
      this.useQuestionPromptLabel = changes?.useQuestionPromptLabel?.currentValue;
    }
    if (changes?.labelText?.currentValue !== changes?.labelText?.previousValue) {
      this.labelText = changes?.labelText?.currentValue;
    }
  }

  saveSliderValue(sliderData: any): void {

    if (this.question) {
      if (sliderData?.sliderValue >= 0 && +this.question?.answer !== sliderData?.sliderValue) {
        this.question.answer = sliderData.sliderValue.toString();
        this.questionAnswer.emit(this.question);
      }
    }
  }
}
